import { createContext, useContext } from 'react';
import { NoteData, PageType, PageTypeKey } from 'components/Notes/types';

interface NotesContextType {
  pageType?: PageType;
  pageTypeKey?: PageTypeKey;
  pageTypeId?: number | string;
  onAddNote?: (note: NoteData) => void;
  onUpdateNotes?: (notes: NoteData) => void;
  onDeleteNote?: (note: NoteData) => void;
  onDeleteNewNote?: (note: NoteData) => void;
}

export const NotesContext = createContext<NotesContextType>({
  pageType: undefined,
  pageTypeKey: undefined,
  pageTypeId: undefined,
  onAddNote: () => {},
  onUpdateNotes: () => {},
  onDeleteNote: () => {},
  onDeleteNewNote: () => {},
});

const useNotesContext = () => useContext(NotesContext);

export default useNotesContext;
